import { useLocation, useNavigate } from "react-router-dom";

import QuizeCheck from "./quizeCheck";
import ChatBoxType2 from "../chat/chatType2";
import { useGame } from "../header/GameContext";
import Header from "../header/header";
import Wrong from "../wrong/wrong";
import { useState, useRef } from "react";

import "./quiz.css";

export default function Quize() {
  const location = useLocation();
  const navigate = useNavigate();

  const { TOTAL_GAME_TIME, isFinalQuiz } = useGame();

  const [showWrong, setShowWrong] = useState(false);

  const chatRef = useRef(null);

  // answerData //스테이지 키(q1, q2...)
  // DateVal //채팅(문제) 키
  const state = location.state || {};
  const { answerData, DateVal, titImgClass } = state;
  // console.log(answerData);
  return (
    <div id="content">
      <Header
        initialTime={TOTAL_GAME_TIME}
        missionCount={3}
        missionTotal={8}
        isFinalQuiz={isFinalQuiz(answerData)}
      />

      <div className="box box_con con_box1 con_pd5 con_box_c ans0001">
        <div className="mission_tit messageTit01"></div>

        <ChatBoxType2
          DateVal={DateVal}
          titImgClass={titImgClass}
          timerMode="run"
          ref={chatRef}
        />

        <QuizeCheck
          onWrong={() => setShowWrong(true)}
          answerData={answerData}
        />

        {showWrong && <Wrong onClose={() => setShowWrong(false)} />}
      </div>
    </div>
  );
}
